import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogContent,
    IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const DialogPopup = () => {
    const [openPopup, setOpenPopup] = useState(false);

    useEffect(() => {
        setOpenPopup(true);
    }, []);

    useEffect(() => {
        const popupShown = sessionStorage.getItem("qrlPopupShown");

        if (!popupShown) {
            setOpenPopup(true);
            sessionStorage.setItem("qrlPopupShown", "true");
        }
    }, []);


    return (
        <Dialog
            open={openPopup}
            onClose={() => setOpenPopup(false)}
            maxWidth="lg"
            fullWidth
        >
            <DialogContent
                sx={{
                    position: "relative",
                    p: "0 55px",
                    overflow: "hidden",
                    backgroundColor: "#f5f5f5",
                }}
            >
                <IconButton
                    onClick={() => setOpenPopup(false)}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 10,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        minHeight: "340px",
                        px: 4,
                    }}
                >
                    {/* Left Image */}
                    <img src={`${process.env.PUBLIC_URL}/Assets/QRL/leftCharacter.png`} style={{marginTop: "15px", width: "200px" }} alt="" />


                    {/* Center Content */}
                    <Box textAlign="left">

                        <Typography
                            fontFamily="Graphik-Bold"
                            fontSize="1.8rem"
                            fontWeight={700}
                        >
                            Ignite wins Bronze at the 2026 Brandon Hall Excellence Awards
                        </Typography>

                        <Typography
                            fontFamily="Graphik-Regular"
                            fontSize="1.2rem"
                            color="#666"
                            mt={2}
                        >
                            We are excited to share a proud milestone! IgNite has been recognized with the Bronze award in the Best Unique or Innovative Leadership Development Program category by the Brandon Hall Excellence Awards. <br /><br />
                            This recognition belongs to all of us. Together, we have shaped IgNite, strengthened its impact, and made this achievement possible. Thank you for being part of our shared success.
                        </Typography>
                    </Box>

                    {/* Right Image */}
                    <img src={`${process.env.PUBLIC_URL}/Assets/QRL/rightCharacter.png`} style={{marginBottom: "10px", width: "120px" }} alt="" />

                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default DialogPopup;